megaMenu();
window.onload = function() {
    setTimeout(() => {
        megaMenu();
    }, 1500);
};


function megaMenu(){
    document.querySelectorAll('.menu-list__list-item .menu-list__submenu .mega-menu__column ul').forEach(function(ul) {
        var foundCount = 0;
        var items = ul.querySelectorAll('li');
        
        items.forEach(function(element) {
            if (element.textContent.trim().startsWith("Shop All")) {
                foundCount++;
                if (foundCount === 1) {
                    element.classList.add('d-mega-parent');
                } else if (foundCount === 2) {
                    element.classList.add('d-mega-parent');
                    element.classList.add('mt-15');
                }
            }
        });
    });
}